import React from 'react';
import icon from '../../../../assets/dbs/db_crossref.png';

const CrossrefIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="crossref"/>
    </div>
);
export default CrossrefIcon;